import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import {extractHtmlText} from "@vue-components/helpers/utils.js";
import EditorPadding from "../../cms/EditorPadding.js";
import CmsBlockFaqList from "./CmsBlockFaqList.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";

export default class CmsBlockFaqItem extends CmsBlock {
    static typeDef = {
        name: `FAQ Item|Question/réponse`,
        glyph: `fas fa-message-question`,
        type: `faq-item`,
        category: `base`,
        isParent: true,
        requiresParent: true,
        hidden: true
    }

    // TODO add layout for image

    get parentClasses() {
        return [CmsBlockFaqList]
    }

    get displayName() {
        if (this.item) {
            return tr(this.item.name);
        } else {
            return extractHtmlText(tr(this.question.text), 24);
        }
    }

    constructor(data, page) {
        super(data, page);

        this.question = new CmsComponentText(this.question);
        this.answer = new CmsComponentText(this.answer);
        this.image = new CmsComponentImage(this.image);

        if (!data) {
            this.question.initText({en: `Question`, fr: `Question`}, `h4`);
            this.question.active = true;

            this.answer.initText({en: `Answer`, fr: `Réponse`}, `p4`);
            this.answer.active = true;

            this.padding = new EditorPadding({left: 20, top: 10, right: 20, bottom: 10});
        } else if (data && !data.image) {
            this.image.active = false;
        }
    }
}
